import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './services/queryClient';
import './index.css';
import { App } from './App';
import { reportWebVitals } from './reportWebVitals';

/**
 * # OAuth2 has a safe authentication with Google
 *
 * More info:
 * @link https://developers.google.com/identity/protocols/oauth2
 * @link https://www.npmjs.com/package/@react-oauth/google
 * @link https://www.youtube.com/watch?v=TqlVP_IkS28
 * @link https://www.youtube.com/watch?v=pAt91MWwwvg
 */
import { GoogleOAuthProvider } from '@react-oauth/google';
import { WindowSizeProvider } from './providers/WindowSizeProvider';
import axios from 'axios';
axios.defaults.withCredentials = true;

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <GoogleOAuthProvider clientId={CLIENT_ID}>
                <WindowSizeProvider>
                    <App />
                </WindowSizeProvider>
            </GoogleOAuthProvider>
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals('');
